import { IProject } from "../../types/project.type"

export enum ProjectActionType {
  FETCH_PROJECTS = "FETCH_PROJECTS",
  FETCH_PROJECTS_SUCCESS = "FETCH_PROJECTS_SUCCESS",
  FETCH_PROJECTS_ERROR = "FETCH_PROJECTS_ERROR",
}

interface FetchProjects {
  type: ProjectActionType.FETCH_PROJECTS
}

interface FetchProjectsSuccess {
  type: ProjectActionType.FETCH_PROJECTS_SUCCESS
  payload: IProject[]
}

interface FetchProjectsError {
  type: ProjectActionType.FETCH_PROJECTS_ERROR
  payload: string
}

export type ProjectAction = FetchProjects | FetchProjectsSuccess | FetchProjectsError

export interface IProjectState {
  projects: IProject[]
  loading: boolean
  error: string | null
}
